import { writable } from 'svelte/store';
export const latestTransactionStore = writable();
